<template>
  <div class="admin">

    <div class="admin-area">

      <div class="row row-gutter-20">
        <div class="col-6">
          <admin-nav></admin-nav>
        </div>
        <div class="col-18">

          <header class="admin-header cf">
            <ul class="nav nav-header cf">
              <li>Extras</li>
            </ul>
            <div class="header-actions">
              <p><router-link to="/admin/vehicle_extras/new" class="button button-orange button-small">Extra hinzufügen ›</router-link></p>
            </div>
          </header>

          <div class="admin-body">

            <div class="search-wrap">
              <input v-model="search_phrase" v-on:input="search_handler" type="text" class="search-field" placeholder="Suchbegriff eingeben...">
            </div>

            <div v-if="loading">
              <div class="loading-wrap">
                <div class="loading-spinner"></div>
              </div>
            </div>
            <div v-else>
              <div v-if="search_loading">
                <div class="loading-wrap">
                  <div class="loading-spinner"></div>
                </div>
              </div>
              <div v-else>

                <table class="table">
                  <thead>
                    <tr>
                      <th width="5%"></th>
                      <th width="55%">Name</th>
                      <th width="30%">Typ</th>
                      <th width="10%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="extra in vehicle_extras" v-bind:key="extra.id">
                      <td>
                        <span v-if="extra.status == 'enabled'" class="status status-green"></span>
                        <span v-if="extra.status == 'disabled'" class="status status-red"></span>
                        <span v-if="extra.status == 'hidden'" class="status status-yellow"></span>
                      </td>
                      <td>
                        <router-link :to="'/admin/vehicle_extras/'+extra.id">
                          {{ extra.name }}
                        </router-link>
                      </td>
                      <td>
                        <span v-if="extra.category == 'kilometer'">Kilometer</span>
                        <span v-if="extra.category == 'insurance'">Versicherung</span>
                        <span v-if="extra.category == 'extra'">Extra</span>
                      </td>
                      <td>
                        <router-link :to="'/admin/vehicle_extras/'+extra.id">
                          <span class="material-icons">create</span>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>

          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import AdminNav from '../../../components/admin_nav'

export default {
  name: 'admin_reservations',
  components: {
    AdminNav
  },
  data () {
    return {
      vehicle_extras: [],
      search_phrase: "",
      search_loading: false,
      loading: true
    }
  },
  methods: {
    get_vehicle_extras() {

      axios.get(process.env.VUE_APP_BASE_API+'/v1/admin/vehicle_extras', { headers: { Authorization: this.$store.getters.getToken }})
      .then(response => {
        console.log(response);
        this.vehicle_extras = response.data.vehicle_extras;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      })

    },
    on_row_click(params) {
      console.log(params.row.id);
      this.$router.push('/admin/vehicle_extras/'+params.row.id);
    },
    search_handler() {
      if (this.search_loading == false) {
        this.search_loading = true;
        axios.get(process.env.VUE_APP_BASE_API+'/v1/admin/vehicle_extras?search_phrase='+this.search_phrase, { headers: { Authorization: this.$store.getters.getToken } })
        .then(response => {
          this.vehicle_extras = response.data.vehicle_extras;
          this.search_loading = false;
        })
        .catch(error => {
          console.log(error);
        })
      }
    }
  },
  mounted () {
    this.get_vehicle_extras();
  }
}
</script>

<style lang="scss">

</style>
